/* =========================================================
   ROVIAN CARE — JS compartido (compra, galería, antes/después,
   tabs, acordeones, fechas de entrega, corte de envío, reveal)
   ========================================================= */
(function () {
  if (window.__rtCare) return;
  window.__rtCare = true;
  document.documentElement.classList.add('rt-js');

  var TZ = 'America/Mexico_City';
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function pad(n) { n = Math.floor(n); return (n < 10 ? '0' : '') + n; }

  /* ---------- Fecha/hora de CDMX como "reloj de pared" ---------- */
  function mxNow() {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second));
  }
  function workDay(d, mode) {
    var w = d.getUTCDay();
    if (mode === 'all') return true;
    if (mode === 'mon_sat') return w !== 0;
    return w !== 0 && w !== 6;
  }
  var DF = new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  var WD = new Intl.DateTimeFormat('es-MX', { weekday: 'long', timeZone: 'UTC' });
  function fmtDay(d) { return DF.format(d).replace(/\./g, '').replace(',', ''); }

  /* ---------- Entrega estimada ---------- */
  function initEta(el) {
    var min = +el.dataset.min || 3, max = +el.dataset.max || 6, mode = el.dataset.days || 'mon_fri';
    var d = mxNow(), a = null, b = null, n = 0;
    while (n < max) { d.setUTCDate(d.getUTCDate() + 1); if (workDay(d, mode)) { n++; if (n === min) a = new Date(d.getTime()); if (n === max) b = new Date(d.getTime()); } }
    $$(el, '[data-min]').forEach(function (x) { x.textContent = fmtDay(a); });
    $$(el, '[data-max]').forEach(function (x) { x.textContent = fmtDay(b); });
  }

  /* ---------- Corte de envío del día ---------- */
  function initCut(el) {
    if (el.__rt) return; el.__rt = 1;
    var h = +el.dataset.h, m = +el.dataset.m || 0, mode = el.dataset.days || 'mon_fri';
    var t = el.querySelector('[data-t]'), bef = el.querySelector('[data-before]'), aft = el.querySelector('[data-after]');
    function tick() {
      var now = mxNow(), cut = new Date(now.getTime());
      cut.setUTCHours(h, m, 0, 0);
      if (workDay(now, mode) && now < cut) {
        var s = Math.floor((cut - now) / 1000);
        if (t) t.textContent = pad(s / 3600) + ':' + pad((s % 3600) / 60) + ':' + pad(s % 60);
        if (bef) bef.hidden = false; if (aft) aft.hidden = true;
      } else {
        var d = new Date(now.getTime()), i = 0;
        do { d.setUTCDate(d.getUTCDate() + 1); i++; } while (!workDay(d, mode) && i < 8);
        $$(el, '[data-dia]').forEach(function (x) { x.textContent = i === 1 ? 'mañana' : 'el ' + WD.format(d); });
        if (bef) bef.hidden = true; if (aft) aft.hidden = false;
      }
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Aviso de urgencia (contador) ---------- */
  function initUrg(el) {
    if (el.__rt) return; el.__rt = 1;
    var mode = el.dataset.mode; if (!mode || mode === 'none') return;
    var tm = el.querySelector('[data-urg-timer]'), hh = el.querySelector('[data-u="h"]'), mm = el.querySelector('[data-u="m"]'), ss = el.querySelector('[data-u="s"]');
    var tx = el.querySelector('[data-urg-text]'), ex = el.querySelector('[data-urg-exp]');
    var end = null;
    if (mode === 'date') {
      var m = (el.dataset.end || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (m) end = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), 59));
    }
    function tick() {
      var now = mxNow(), target;
      if (mode === 'today') {
        target = new Date(now.getTime()); target.setUTCHours(+el.dataset.h || 0, +el.dataset.m || 0, 0, 0);
        if (target <= now) target.setUTCDate(target.getUTCDate() + 1);
      } else target = end;
      if (!target) return;
      var s = Math.floor((target - now) / 1000);
      if (s <= 0) {
        if (ex) { ex.hidden = false; if (tx) tx.hidden = true; if (tm) tm.hidden = true; } else el.hidden = true;
        clearInterval(el.__t); return;
      }
      var h = Math.floor(s / 3600);
      hh.textContent = h > 99 ? h : pad(h); mm.textContent = pad((s % 3600) / 60); ss.textContent = pad(s % 60);
    }
    tick(); el.__t = setInterval(tick, 1000);
  }

  /* ---------- Galería ---------- */
  function initGal(g) {
    if (g.__rt) return; g.__rt = 1;
    var tr = g.querySelector('[data-track]'); if (!tr) return;
    var n = tr.children.length, th = $$(g, '[data-th]'), cnt = g.querySelector('[data-cnt]'), thw = g.querySelector('.rtb-thumbs'), cur = -1;
    function go(i) { i = Math.max(0, Math.min(n - 1, i)); tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); }
    function upd() {
      var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
      if (i === cur) return; cur = i;
      th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
      if (th[i] && thw) { var l = th[i].offsetLeft - thw.clientWidth / 2 + th[i].clientWidth / 2; thw.scrollTo({ left: l, behavior: 'smooth' }); }
    }
    tr.addEventListener('scroll', function () { clearTimeout(tr.__t); tr.__t = setTimeout(upd, 50); }, { passive: true });
    th.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var pv = g.querySelector('[data-prev]'), nx = g.querySelector('[data-next]');
    if (pv) pv.addEventListener('click', function () { go(cur - 1 < 0 ? n - 1 : cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1 >= n ? 0 : cur + 1); });
    upd();
  }

  /* ---------- Compra ---------- */
  function initBuy(root) {
    if (root.__rt) return; root.__rt = 1;
    var packs = $$(root, 'input[data-pack]');
    var main = root.querySelector('[data-rt-atc-main]');
    var err = root.querySelector('[data-rt-err]');
    var cur = { id: root.dataset.vid, qty: 1, pf: null, cf: null, sf: null, t: null };

    function paint() {
      if (cur.pf !== null) $$(root, '[data-rt-p]').forEach(function (e) { e.textContent = cur.pf; });
      if (cur.cf !== null) $$(root, '[data-rt-c]').forEach(function (e) { e.textContent = cur.cf; e.hidden = !cur.cf; });
      if (cur.sf !== null) $$(root, '[data-rt-s]').forEach(function (e) { e.textContent = cur.sf; e.hidden = !cur.sf; });
      if (cur.t !== null) $$(root, '[data-rt-pt]').forEach(function (e) { e.textContent = cur.t; e.hidden = !cur.t; });
      if (cur.img) $$(root, '[data-rt-simg]').forEach(function (e) { if (e.getAttribute('src') !== cur.img) e.src = cur.img; });
    }
    function pick(inp) {
      packs.forEach(function (x) { var l = x.closest('.rtb-pack'); if (l) l.classList.toggle('is-on', x === inp); });
      cur = { id: inp.dataset.id, qty: +inp.dataset.qty || 1, pf: inp.dataset.pf, cf: inp.dataset.cf || '', sf: inp.dataset.sf || '', t: inp.dataset.title || '', img: inp.dataset.simg || '' };
      paint();
    }
    packs.forEach(function (inp) { inp.addEventListener('change', function () { if (inp.checked) pick(inp); }); });
    var first = packs.filter(function (x) { return x.checked; })[0] || packs.filter(function (x) { return !x.disabled; })[0];
    if (first) { first.checked = true; pick(first); }

    function showErr(msg) { if (!err) return alert(msg); err.textContent = msg; err.classList.add('is-on'); }

    function add(btn) {
      if (!cur.id || btn.classList.contains('is-loading')) return;
      if (err) err.classList.remove('is-on');
      var action = (main && main.dataset.action) || 'drawer';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: +cur.id, quantity: cur.qty }] };
      var useDrawer = action === 'drawer' && drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
      if (useDrawer) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.classList.add('is-loading'); btn.disabled = true;
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { showErr(res.j.description || res.j.message || 'No se pudo agregar. Intenta de nuevo.'); return; }
          document.dispatchEvent(new CustomEvent('rt:added', { detail: res.j }));
          if (action === 'checkout') { window.location.href = '/checkout'; return; }
          if (useDrawer) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
        .finally(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    }
    $$(root, '[data-rt-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(b); }); });

    // Sticky: aparece cuando el botón principal ya quedó arriba
    var st = root.querySelector('[data-rt-sticky]');
    if (st && main) {
      var last = null, raf = 0;
      var check = function () {
        raf = 0;
        if (!document.body.contains(main)) return;
        var on = main.getBoundingClientRect().bottom < 0;
        if (on === last) return; last = on;
        st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$(st, 'button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      };
      var req = function () { if (!raf) raf = requestAnimationFrame(check); };
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      check();
    }
  }

  /* ---------- Antes / después ---------- */
  function initCmp(c) {
    if (c.__rt) return; c.__rt = 1;
    var r = c.querySelector('input'), drag = false, touched = false;
    function set(v) { v = Math.max(0, Math.min(100, v)); c.style.setProperty('--pos', v + '%'); if (r) r.value = Math.round(v); }
    function fromX(x) { var b = c.getBoundingClientRect(); set((x - b.left) / b.width * 100); }
    c.addEventListener('pointerdown', function (e) { drag = true; touched = true; if (e.pointerType === 'mouse') { fromX(e.clientX); try { c.setPointerCapture(e.pointerId); } catch (x) {} } });
    c.addEventListener('pointermove', function (e) { if (drag) fromX(e.clientX); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { c.addEventListener(t, function () { drag = false; }); });
    if (r) r.addEventListener('input', function () { touched = true; set(+r.value); });
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var t0 = null, keys = [50, 22, 78, 50], dur = 2200;
        function step(ts) {
          if (touched) return; if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur), seg = k * 3, i = Math.min(2, Math.floor(seg)), f = seg - i;
          f = f < .5 ? 2 * f * f : 1 - Math.pow(-2 * f + 2, 2) / 2;
          set(keys[i] + (keys[i + 1] - keys[i]) * f);
          if (k < 1) requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 400);
      }, { threshold: .5 });
      io.observe(c);
    }
  }

  /* ---------- Tabs ---------- */
  function initTabs(wrap) {
    if (wrap.__rt) return; wrap.__rt = 1;
    var sec = wrap.closest('section') || document, tabs = $$(wrap, '[data-i]'), panes = $$(sec, '[data-pane]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.dataset.i;
        tabs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panes.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      });
    });
  }

  /* ---------- Carrusel con puntos ---------- */
  function initDots(rail) {
    if (rail.__rt) return; rail.__rt = 1;
    var dots = rail.parentNode.querySelector('.rtu-dots'); if (!dots) return;
    var items = rail.children, ds = $$(dots, 'i');
    rail.addEventListener('scroll', function () {
      var w = items[0] ? items[0].getBoundingClientRect().width + 14 : 1, i = Math.round(rail.scrollLeft / w);
      ds.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
  }

  /* ---------- Acordeón de una sola apertura ---------- */
  function initOne(wrap) {
    if (wrap.__rt) return; wrap.__rt = 1;
    var ds = $$(wrap, 'details');
    ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
  }

  /* ---------- Botones que bajan a la compra ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-rt-go]'); if (!a) return;
    var buy = document.querySelector('[data-rt-buy]'); if (!buy) return;
    e.preventDefault();
    var target = buy.querySelector('.rtb-packs') || buy;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* ---------- Reveal ---------- */
  var rio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function init(scope) {
    scope = scope || document;
    $$(scope, '[data-rt-buy]').forEach(initBuy);
    $$(scope, '[data-gal]').forEach(initGal);
    $$(scope, '[data-rt-eta]').forEach(initEta);
    $$(scope, '[data-rt-cut]').forEach(initCut);
    $$(scope, '[data-rt-urg]').forEach(initUrg);
    $$(scope, '[data-rt-cmp]').forEach(initCmp);
    $$(scope, '[data-rt-tabs]').forEach(initTabs);
    $$(scope, '.rtu-rail').forEach(initDots);
    $$(scope, '[data-rt-one]').forEach(initOne);
    $$(scope, '.rt-rv').forEach(function (el) { if (rio) rio.observe(el); else el.classList.add('is-in'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var p = e.target.closest && e.target.closest('[data-pane]');
    if (p) { var sec = p.closest('section'), panes = $$(sec, '[data-pane]'), i = panes.indexOf(p), tab = sec.querySelector('[data-rt-tabs] [data-i="' + i + '"]'); if (tab) tab.click(); }
    if (e.target.classList && e.target.classList.contains('rt-rv')) e.target.classList.add('is-in');
  });
})();
